<template>
    <v-row class="white pl-3 pr-3 ml-0 mr-0 pb-5">
        <v-col cols="12">
            <v-card class="documentos">
                <v-expansion-panels v-model="expandir" flat multiple>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="documentos-panel-header">
                            <h4 class="session-title">Patrimônios (1)</h4>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="mt-4">
                            <v-col cols="12" md="12" class="mt-0 pt-0">
                                <Tabela
                                    :key="keyTabela"
                                    class="table-patrimonio-ajuste"
                                    :colunas="colunas"
                                    :lista="[{...ajuste}]"
                                    :paginacaoAtiva="false"
                                    desabilitaAlturaMaxima
                                />
                            </v-col>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import Tabela from '@/views/components/tabela/Tabela.vue'
    import {tipoAjuste} from '@/core/constants'

    export default {
        name: 'AjusteDetalhePatrimonios',
        components: {Tabela},
        props: {
            ajuste: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                expandir: [0],
                keyTabela: 0
            }
        },
        computed: {
            colunas () {
                if(this.ajuste.tipo === tipoAjuste.REDUCAO_AO_VALOR_RECUPERAVEL){
                    return this.criarColunas(
                        ['N° Patrimônio', 'Descrição', 'Valor Entrada', 'Valor Bruto','Valor Líquido',
                            'Período Licença', 'Valor reduzido','Novo Valor Bruto', 'Novo Valor Líquido',],
                        ['patrimonioNumero', 'descricao', 'valorEntradaAnterior','valorBrutoAnterior', 'valorLiquidoAnterior',
                            'periodoLicenca', 'impairment','valorBrutoPosterior', 'valorLiquidoPosterior' ],
                        [false, false, false, false, false, false, false, false, false],
                        ['left', 'left', 'left', 'left', 'left', 'left', 'left', 'left','left'],
                        [5, 15, 5, 5, 5, 10, 5, 5, 5],
                        'gray--text',
                        [(patrimonioNumero) => { return this.$options.filters.textoSemValorSimples(patrimonioNumero) },
                            (descricao) => { return this.$options.filters.textoSemValorSimples(descricao) },
                            (valorEntradaAnterior) => { return this.$options.filters.valorParaDinheiro(valorEntradaAnterior) },
                            (valorBrutoAnterior) => { return this.$options.filters.valorParaDinheiro(valorBrutoAnterior) },
                            (valorLiquidoAnterior) => { return this.$options.filters.valorParaDinheiro(valorLiquidoAnterior) },
                            (periodoLicenca) => { return this.$options.filters.textoSemValorSimples(periodoLicenca) },
                            (impairment) => { return this.$options.filters.valorParaDinheiro(impairment) },
                            (valorBrutoPosterior) => { return this.$options.filters.valorParaDinheiro(valorBrutoPosterior) },
                            (valorLiquidoPosterior) => { return this.$options.filters.valorParaDinheiro(valorLiquidoPosterior) },]
                    )
                }
                return this.criarColunas(
                    ['N° Patrimônio', 'Descrição', 'Valor Entrada','Valor Bruto', 'Valor Líquido',
                     'Período Licença', 'Valor Acrescido', 'Novo Valor Bruto', 'Valor Líquido Final'],
                    ['patrimonioNumero', 'descricao', 'valorEntradaAnterior','valorBrutoAnterior', 'valorLiquidoAnterior',
                     'periodoLicenca', 'valorAcrescido', 'valorBrutoPosterior', 'valorLiquidoPosterior'],
                    [false, false, false, false, false, false, false, false, false],
                    ['left', 'left', 'left', 'left', 'left', 'left', 'left', 'left', 'left'],
                    [5, 15, 5, 5, 5, 10, 5, 5, 5],
                    'gray--text',
                    [(patrimonioNumero) => { return this.$options.filters.textoSemValorSimples(patrimonioNumero) },
                     (descricao) => { return this.$options.filters.textoSemValorSimples(descricao) },
                     (valorEntradaAnterior) => { return this.$options.filters.valorParaDinheiro(valorEntradaAnterior) },
                     (valorBrutoAnterior)=> { return this.$options.filters.valorParaDinheiro(valorBrutoAnterior) },
                     (valorLiquidoAnterior) => { return this.$options.filters.valorParaDinheiro(valorLiquidoAnterior) },
                     (periodoLicenca) => { return this.$options.filters.textoSemValorSimples(periodoLicenca) },
                     (valorAcrescido) => { return this.$options.filters.valorParaDinheiro(valorAcrescido) },
                     (valorBrutoPosterior) => { return this.$options.filters.valorParaDinheiro(valorBrutoPosterior) },
                     (valorLiquidoPosterior) => { return this.$options.filters.valorParaDinheiro(valorLiquidoPosterior) },]
                )
            }
        }

    }
</script>

<style lang="stylus" scoped>
    .session-title
        font-size 15px
        font-weight bold
        color #777 !important

</style>
